import { UPDATE_CURRENT_FILTERS } from "./types";

export default filters => {
    return { type: UPDATE_CURRENT_FILTERS, payload: filters }
};
